export default __webpack_public_path__ + "static/alex-19dfd3efb6c0c3530c2a1840ad11f4e4.jpg";